import UILink from 'UIComponents/link/UILink';
import styled from 'foundations-theming-specialty/utils';
const AILink = styled(UILink).attrs({
  iconProps: {
    style: {
      color: theme => theme.color['text-core-default']
    }
  }
}).withConfig({
  displayName: "AILink",
  componentId: "cxpjij-0"
})(["color:", " !important;&:hover{color:", " !important;}&:active{color:", " !important;}"], ({
  theme
}) => theme.color['breeze-text-badge-default'], ({
  theme
}) => theme.color['breeze-icon-icon-button-hover'], ({
  theme
}) => theme.color['breeze-icon-icon-button-pressed']);
export default AILink;